import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SALES_CATALYST_API_AUDIENCE } from '../../constants';
import searchIcon from '../../images/search-icon.png';
import clearIconBlue from '../../images/clear-field-icon_b.png';
import * as salesAction from '../../actions/salesCatalystActions';

class SalesSectionSearchComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgDisplay: false,
      nodes: [],
      prevSearchText: '',
      selectedItem: '',
      salesSectionSearchItem: [],
      activeAccountId: '',
      token: '',
      showSearchResult: this.props.showSearchResult !== undefined ? this.props.showSearchResult : false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.activeAccountId !== nextProps.activeAccountId) {
      this.setState({ activeAccountId: nextProps.activeAccountId });
    }
    if (this.props.showSearchResult !== nextProps.showSearchResult) {
      this.setState({ showSearchResult: nextProps.showSearchResult });
    }
  }

  // handleOnChange = () => {
  // };

  handleSearch = () => {
    this.setState({
      salesSectionSearchResult: [],
    });
    const actionParams = {
      token: this.props.loginResponse.data.token,
      userId: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.productNo,
      type: SALES_CATALYST_API_AUDIENCE,
      searchText: this.searchBox.value,
    };
    this.props.salesAction.scActionGetMethod(actionParams).then(response => {
      this.setState({
        salesSectionSearchItem: response,
      });
      this.props.setShowSearchResult(!this.state.showSearchResult, this.props.section);
    });
  };

  handleClear = () => {
    this.searchBox.value = '';
    this.props.setShowSearchResult(!this.state.showSearchResult, this.props.section);
  };

  resetSearchBlockState = updateState => {
    updateState = this.state.showSearchResult;
    return updateState;
  }


  handleItemClick = item => {
    this.props.setShowSearchResult(!this.state.showSearchResult, this.props.section);
    this.searchBox.value = item.templateName;
    this.setState({
      showSearchResult: false,
      selectedItem: this.selectedItem.textContent,
    });
    this.props.loadAction(this.props.section, item.templateId);
  }

  render() {
    return (
      <div className="scs-search-bar">
        <input
          type="text"
          id={`${this.props.section}-search-box`}
          placeholder="Search"
          onChange={this.handleOnChange}
          ref={searchBox => {
            this.searchBox = searchBox;
          }}
        />
        {(!this.state.showSearchResult) && (
          <button
            type="button"
            className="sales-search-bar-icon"
            onClick={this.handleSearch}
          >
            <img src={searchIcon} alt="search" />
          </button>
        )}
        {(this.state.showSearchResult) && (
          <button
            type="button"
            className="sales-search-bar-icon"
            onClick={() => { this.handleClear(); }}
          >
            <img src={clearIconBlue} alt="clear" />
          </button>
        )}
        {this.state.showSearchResult && (this.state.salesSectionSearchItem !== undefined &&
        this.state.salesSectionSearchItem.length > 0) && (

          <div className="searchList" id={`${this.props.section}-search-block`}>
            <div className="searchBlock">
              {this.state.salesSectionSearchItem.map((node, index) => (
                <div
                  key={`search-item${index}`}
                  className="item-list"
                >
                  <ul className="list-unstyled">
                    <li
                      onClick={() => this.handleItemClick(node)}
                      key={node}
                      ref={node => {
                        this.selectedItem = node;
                      }}
                    >
                      <span className="search-list-Item">{node.templateName}</span>
                    </li>
                  </ul>
                </div>
            ))}
            </div>
          </div>
        )}
        {this.state.showSearchResult && (this.state.salesSectionSearchItem.length === 0) && (
          <div className="searchList"><div className="searchBlock">
            <span className="errorMsg">No Results Found. Please refine your search.</span>
          </div>
          </div>
         )}
      </div>
    );
  }
}

SalesSectionSearchComponent.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  salesAction: PropTypes.shape({
    clearSearchResult: PropTypes.func,
    scActionGetMethod: PropTypes.func,
  }),
  showSearchResult: PropTypes.bool,
  brandSearchFlag: PropTypes.bool,
  setShowSearchResult: PropTypes.func,
  section: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    activeAccountId: state.account.activeAccountId,
    loginResponse: state.login.loginResponse,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
    typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
    state.study.salesCatalystStudy.pn : 0,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesAction: bindActionCreators(salesAction, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
)(SalesSectionSearchComponent);
